import { InputText } from "@bluframe/blublocks"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldRow,
  FieldValue
} from "components/Fields/styled"

import { ComponentProps } from "."

const UrlAndDomainRow = ({
  domainRef,
  isEditMode,
  item,
  urlRef
}: Pick<ComponentProps, "domainRef" | "isEditMode" | "item" | "urlRef">) => (
  <FieldRow $items={2}>
    {isEditMode ? (
      <>
        <InputText
          defaultValue={item?.url ?? ""}
          inputId="url"
          label="Url"
          name="url"
          ref={urlRef}
          required
        />

        <InputText
          defaultValue={item?.domain ?? ""}
          inputId="domain"
          label="Domain"
          name="domain"
          ref={domainRef}
        />
      </>
    ) : (
      <>
        <FieldLabelAndValue>
          <FieldLabel>{"Url"}</FieldLabel>

          <FieldValue>{item?.url}</FieldValue>
        </FieldLabelAndValue>

        <FieldLabelAndValue>
          <FieldLabel>{"Domain"}</FieldLabel>

          <FieldValue>{item?.domain}</FieldValue>
        </FieldLabelAndValue>
      </>
    )}
  </FieldRow>
)

export default UrlAndDomainRow
